/**
 * Identidade jurídica do FIVI360.
 * Única fonte para razão/nome empresarial, CNPJ e e-mail institucional.
 * Não incluir endereço, DPO, CPF ou outros dados não fornecidos.
 */
export const LEGAL_ENTITY = Object.freeze({
  productName: "FIVI360",
  legalName: "49.712.355 INOVA SIMPLES (I.S.)",
  cnpj: "49.712.355/0001-00",
  contactEmail: "contato@fivi360.com.br",
});
